
import React from "react";
import ExamContent from "./exam";
import reducer from "../journal/services";
import withReducer from "services/withReducer";

function Exam() {
  return <ExamContent />;
}
export default withReducer("Exam", reducer)(Exam);
